import React, {useCallback, useContext, useEffect, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    FormControl, FormControlLabel,
    FormHelperText,
    Grid,
    InputLabel, Radio, RadioGroup,
    Typography,
    useToastProvider
} from '@deere/fuel-react';
import {generateDisplayName, toCapitalize} from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import {useOktaAuth} from '@okta/okta-react';
import {Controller, useForm} from "react-hook-form";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {CREATE_TEAM_SUPPLIER_STATE, SELECT_TEAM_LEAD_TEXT} from "../shared/Constants";
import {ModalDialog} from "../shared/ModalDialog";
import {Chip} from "@material-ui/core";
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from "@material-ui/icons/Warning";
import {TeamMembersCard} from "./TeamMembersCard"
import {PotentialTeamMembers} from "./PotentialTeamMembers"
import {UserContext} from "./Main";

export const TeamsCreateEdit = ({name}) => {
    let history = useHistory();
    let authAxios = useAuthConfig();
    const {authState} = useOktaAuth();
    const {enqueueToast} = useToastProvider();
    let {teamId} = useParams();
    const {control, getValues} = useForm();
    const info = useContext(UserContext);
    const isCriteriaAdmin = info && info.isCriteriaAdmin;
    const [stakeholdersList, setStakeholdersList] = useState([]);
    const [selectedStakeHolders, setSelectedStakeHolders] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [supplierData, setSupplierData] = useState(CREATE_TEAM_SUPPLIER_STATE);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addDisable, setAddDisable] = useState(true);
    const [isSupplierNumberEmpty, setIsSupplierNumberEmpty] = useState(false);
    const [isTeamMemberEmpty, setIsTeamMemberEmpty] = useState(false);
    const [isRacfIDEmpty, setIsRacfIDEmpty] = useState(false);
    const [isRoleEmpty, setIsRoleEmpty] = useState(false);
    const [isUnitEmpty, setIsUnitEmpty] = useState(false);
    const [selectedSupplierNumber, setSelectedSupplierNumber] = useState("");
    const [selectedSupplierName, setSelectedSupplierName] = useState("");
    const [selectedFunctionalArea, setSelectedFunctionalArea] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorDesc, setErrorDesc] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [alertVariant, setAlertVariant] = useState("error");
    const initSbmData = [{value: "1", label: "SBM", user: "", valid: true},
        {value: "2", label: "SRO", user: "", valid: true},
        {value: "3", label: "GRO", user: "", valid: true}]
    const [sbmData, setSbmData] = useState(initSbmData)
    const [selectedData, setSelectedData] = useState("");
    const [selectedSubFunctionalArea, setSelectedSubFunctionalArea] = useState("");
    const [isFunctionalAreaError, setIsFunctionalAreaError] = useState(false);
    const [functionalAreaAlertVariant, setFunctionalAreaAlertVariant] = useState("error");
    const [functionalAreaErrorDesc, setFunctionalAreaErrorDesc] = useState("");

    const getSupplierDetails = async (supplierNumber) => {
        try {
            return await authAxios.get(`/ratingSupplierDetail/${supplierNumber}`);
        } catch (e) {
            console.error(e);
        }
    };

    const getSuppliersList = async (value) => {
        setLoading(true);
        try {
            const res = await authAxios.get(`/suppliers?queryString=${value}`);
            setOptions(res.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleValueChange = (value) => {
        setSbmData(initSbmData);
        setStakeholdersList([]);
        setIsLoading(true);
        setIsSupplierNumberEmpty(false);
        setErrorMsg("");
        setErrorDesc("");
        setSupplierData(CREATE_TEAM_SUPPLIER_STATE);

        if (!value || !value.supplierNumber) {
            setIsLoading(false);
            return;
        }

        value && getSupplierDetails(value.supplierNumber).then(res => {
            if (res && !res.data.functionalAreaType) {
                setErrorMsg("No SRO record found");
                setErrorDesc("Please update SRO before creating AE Rating team");
                setAddDisable(true);
            } else {
                getRoles(res.data.functionalAreaType).then(res => {
                    setRoleList(res.data);
                });
                setSbmData([
                    {
                        value: `SBM-${res.data.sbm.userId}`,
                        label: "SBM:",
                        user: generateDisplayName(res.data.sbm.firstName, res.data.sbm.lastName, res.data.sbm.userId),
                        valid: true
                    },
                    {
                        value: `SRO-${res.data.sro.userId}`,
                        label: "SRO:",
                        user: generateDisplayName(res.data.sro.firstName, res.data.sro.lastName, res.data.sro.userId),
                        valid: true
                    },
                    {
                        value: `GRO-${res.data.gro.userId}`,
                        label: "GRO:",
                        user: generateDisplayName(res.data.gro.firstName, res.data.gro.lastName, res.data.gro.userId),
                        valid: true
                    }
                ])
                if (res.data.sbm.userId !== undefined) {
                    setSelectedData(`SBM-${res.data.sbm.userId}`);
                } else if (res.data.sro.userId !== undefined) {
                    setSelectedData(`SRO-${res.data.sro.userId}`);
                } else if (res.data.gro.userId !== undefined) {
                    setSelectedData(`GRO-${res.data.gro.userId}`);
                }
                setSupplierData(res.data);
                setAddDisable(false);
            }
            setIsLoading(false);
        });
    }


    const onCancel = () => {
        history.push("/rating-teams");
    }

    const getRoles = async (functionalCode) => {
        try {
            return await authAxios.get(`/stakeholders?functionalAreaCodes=` + functionalCode);
        } catch (e) {
            console.error(e);
        }
    };

    const getUnits = async () => {
        try {
            return await authAxios.get(`/units`);
        } catch (e) {
            console.error(e);
        }
    };

    const onRespTypeChange = event => {
        setSelectedData(event.target.value);
    };

    const handleSave = () => {
        let error = false;
        const supplierNumber = getValues("supplier") ? getValues("supplier").supplierNumber : selectedSupplierNumber;
        const functionalArea = supplierData.functionalAreaType ? supplierData.functionalAreaType : selectedFunctionalArea;

        if (!supplierNumber) {
            setIsSupplierNumberEmpty(true);
            return false;
        }
        if (stakeholdersList.length === 0) {
            setIsTeamMemberEmpty(true);
            return false;
        }

        const filterDeletedStakeholdersList = stakeholdersList?.filter(item => !(item.status === "D"));
        if (filterDeletedStakeholdersList.length === 0) {
            setIsTeamMemberEmpty(true);
            return false;
        }
        if (filterDeletedStakeholdersList) {
            filterDeletedStakeholdersList.forEach(item => {
                if (item.user.racfID === "") {
                    setIsRacfIDEmpty(true);
                    error = true
                    return false;
                }
                if (item.role === null || !Object.keys(item.role).includes("id")) {
                    setIsRoleEmpty(true);
                    error = true
                    return false;
                }
                if (item.unit === "" || (item.unit && !item.unit.description)) {
                    setIsUnitEmpty(true);
                    error = true
                    return false;
                }
            });
            if (!error) {
                const teamDataInFormat = stakeholdersList
                    .filter(item => (item.user.racfID !== "" && item.role && "id" in item.role && item.unit && item.unit.description))
                    .map(item => ({
                        id: item.id,
                        racfId: item.user.racfID,
                        name: `${item.user.lastName} ${item.user.firstName}`,
                        role: item.role ? item.role : {},
                        unit: item.unit,
                        showNameInSps: "Y",
                        teamLeader: "N",
                        status: item.status
                    }));
                let selectedObject;
                if (selectedData) {
                    const userData = selectedData.split('-');
                    let userRole;
                    if (userData[0] === "SBM") {
                        userRole = {id: 64, description: roleList.filter(item => item.id === 64)[0].description}
                    }
                    if (userData[0] === "SRO") {
                        userRole = {id: 63, description: roleList.filter(item => item.id === 63)[0].description}
                    }
                    if (userData[0] === "GRO") {
                        userRole = {id: 65, description: roleList.filter(item => item.id === 65)[0].description}
                    }
                    selectedObject = {
                        id: stakeholdersList.length + 1,
                        racfId: userData[1],
                        role: userRole,
                        unit: {id: "E000", description: unitList.filter(item => item.id === "E000")[0].description},
                        teamLeader: "Y",
                        showNameInSps: "Y",
                        status: "U"
                    }
                    teamDataInFormat.push(selectedObject)
                }
                const teamData = {
                    supplierNumber: supplierNumber,
                    functionalAreaType: functionalArea,
                    teamMembers: teamDataInFormat
                }
                if (teamId) putData(teamData)
                else {
                    const postTeamData = {
                        ...teamData,
                        teamMembers: teamDataInFormat.filter(item => item.status !== "D")
                    }
                    postData(postTeamData)
                }
                setIsRacfIDEmpty(false)
                setIsRoleEmpty(false)
                setIsUnitEmpty(false)
                setErrorMsg("")
                setStakeholdersList(stakeholdersList)
            } else {
                setErrorMsg("Please fill all the details")
            }
        }
    }

    const postData = async (data) => {
        await authAxios.post(`/team`, data)
            .then(res => {
                enqueueToast({
                    variant: "success",
                    title: "Rating Team created",
                    isCloseable: true
                });
                history.replace(`/rating-teams/edit-team/${res.data}`);

            }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: error.response && error.response.data[error.response.status] ? error.response.data[error.response.status] : "System Error",
                    isPersistent: true
                });
            });
    };

    const putData = async (data) => {
        await authAxios.put(`/team`, data)
            .then(res => {
                getTeamDetails().then(res => {
                    processData(res.data);
                })
                enqueueToast({
                    variant: "success",
                    title: "Rating Team updated",
                    isCloseable: true
                });
                console.log(res.data);
            }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: error.response ? error.response.data[error.response.status] : "System Error",
                    isPersistent: true
                });
                console.log(error.response);
            });
    };

    const getTeamDetails = async () => {
        try {
            return await authAxios.get(`/teams/${teamId}`);
        } catch (e) {
            console.error(e);
        }
    };

    const onDelete = async () => {
        await authAxios.delete(`/teams/${teamId}`)
            .then(res => {
                console.log(res.data);
                enqueueToast({
                    variant: "success",
                    title: "Rating team Deleted Successfully",
                    isCloseable: true
                });
                setTimeout(() => {
                    history.replace(`/rating-teams`);
                }, 2000);
            }).catch((error) => {
                enqueueToast({
                    variant: "error",
                    title: "System Error",
                    isPersistent: true
                });
                console.log(error);
            });
    }

    const processData = data => {
        const tempArr = data.teamMembers.filter(item => item.teamLeader !== "Y").map(item => {
            const tempName = item.name && item.name.split(", ")
            item.user = item.name && {
                description: `${item.name} - ${item.racfId}`,
                firstName: tempName[1],
                lastName: tempName[0],
                racfID: item.racfId
            }
            item.status = ""
            return item
        })

        setStakeholdersList(tempArr);
        setSelectedSupplierNumber(data.supplierNumber);
        setSelectedSupplierName(data.supplierName);
        setSelectedFunctionalArea(data.functionalAreaType);
        setSelectedSubFunctionalArea(data.subFunctionalAreaType)
        setSupplierData(data)

        const initialSbmData = [
            {
                value: `SBM-${data.sbm.userId}`,
                label: "SBM:",
                user: generateDisplayName(data.sbm.firstName, data.sbm.lastName, data.sbm.userId),
                valid: true
            },
            {
                value: `SRO-${data.sro.userId}`,
                label: "SRO:",
                user: generateDisplayName(data.sro.firstName, data.sro.lastName, data.sro.userId),
                valid: true
            },
            {
                value: `GRO-${data.gro.userId}`,
                label: "GRO:",
                user: generateDisplayName(data.gro.firstName, data.gro.lastName, data.gro.userId),
                valid: true
            }
        ]
        const selectedData = data.teamMembers.filter(item => item.teamLeader === "Y");

        if (data.isOldLeadPresent === "Y") {
            let selectedRole

            if (selectedData[0]?.role?.id === "63")
                selectedRole = "SRO"
            else if (selectedData[0]?.role?.id === "64")
                selectedRole = "SBM"
            else if (selectedData[0]?.role?.id === "65")
                selectedRole = "GRO"

            const updatedSbmData = initialSbmData.map(item => {
                const value = item.value.split('-');
                if (value[0] === selectedRole) {
                    item.valid = false
                }
                return item
            })
            setSbmData(updatedSbmData)
            setSelectedData(`${selectedRole}-${data.newUser.racfID}`)
            setErrorMsg("user updated")
            setAlertVariant("warning")
            setErrorDesc(`${generateDisplayName(data.newUser.firstName, data.newUser.lastName, data.newUser.racfID)} 
                            replaced ${selectedData[0].name} - ${selectedData[0].racfId} as ${selectedRole}. Click Save to Update. (Only for TEAM LEAD)`)
        } else {
            setErrorMsg("")
            setAlertVariant("error")
            setErrorDesc("")
            setSbmData(initialSbmData)
            if (selectedData[0]?.role?.id === "63") {
                setSelectedData(`SRO-${selectedData[0].racfId}`)
            }
            if (selectedData[0]?.role?.id === "64") {
                setSelectedData(`SBM-${selectedData[0].racfId}`)
            }
            if (selectedData[0]?.role?.id === "65") {
                setSelectedData(`GRO-${selectedData[0].racfId}`)
            }
        }

        if (data.isFunctionalAreaSROMatched === false) {
            setIsFunctionalAreaError(true)
            setFunctionalAreaAlertVariant("warning")
            setFunctionalAreaErrorDesc(`Functional area from SRO (${data.sroFunctionalAreaType}) is different from AE supplier functional Area.`)
        }

        setAddDisable(false)
        setIsLoading(false)
    }

    const handleUpdateStakeholder = (data) => {
        setIsRacfIDEmpty(false)
        setIsRoleEmpty(false)
        setIsUnitEmpty(false)
        setErrorMsg("")
        setStakeholdersList(data)
    }

    const handleUpdateRacfId = (data) => {
        setIsRacfIDEmpty(data)
    }

    const handleUpdateRole = (data) => {
        setIsRoleEmpty(data)
    }

    const handleUnitEmpty = (data) => {
        setIsUnitEmpty(data)
    }

    const handleTeamMemberEmpty = (data) => {
        setIsTeamMemberEmpty(data)
    }

    const handleErrorMsg = (data) => {
        setErrorMsg(data)
    }

    const handleSelectedStakeholders = (data) => {
        setSelectedStakeHolders(data);
    };

    /**
     * AI-GENERATED
     * Handles adding a potential member to the stakeholders list
     * @param {Object} member - The member object to add
     */
    const handleAddPotentialMember = useCallback((member) => {
        const newStakeholder = {
            id: stakeholdersList.length + 1,
            user: {
                description: `${member.lastName}, ${member.firstName} - ${member.racfId}`,
                firstName: member.firstName,
                lastName: member.lastName,
                racfID: member.racfId
            },
            role: null,
            unit: "",
            status: "A"
        };
        
        const updatedList = [...stakeholdersList, newStakeholder];
        setStakeholdersList(updatedList);
        
        // Reset validation errors
        setIsTeamMemberEmpty(false);
        setErrorMsg("");
    }, [stakeholdersList]);

    useEffect(() => {
        if (teamId) {
            setIsLoading(true)
            getTeamDetails().then(res => {
                if (res) {
                    processData(res.data)
                    getRoles(res.data.functionalAreaType).then(res => {
                        setRoleList(res.data);
                    });
                }
                setIsLoading(false)
            })
        }

        getUnits().then(res => {
            setUnitList(res.data);
        });

        return () => {
            setRoleList([]);
            setUnitList([]);
            setErrorMsg("");
            setErrorDesc("");
            setAddDisable(true);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <form onSubmit={handleSave}>
            <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} md={8}>
                    <Typography variant="h3" component="h3" display="inline">
                        {`${name}${teamId && selectedSupplierNumber ? ` - ${parseInt(selectedSupplierNumber)}` : ""}`}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box display="flex" justifyContent="flex-end">
                        {(teamId && isCriteriaAdmin) && (
                            <ModalDialog
                                titleText={"Delete Rating Team"}
                                content="Are you sure you want to delete this Rating Team?"
                                saveButtonText={"Delete"}
                                onSave={onDelete}
                                page={"Campaign"}
                            />
                        )}
                        <Button variant="secondary" style={{marginRight: "1rem"}} size="large" onClick={onCancel}>Cancel</Button>
                        <Button variant="primary" style={{marginRight: "1rem"}} size="large" onClick={handleSave}>Save</Button>
                    </Box>
                </Grid>
                {(isRacfIDEmpty || isRoleEmpty || isUnitEmpty || errorMsg) && (
                    <Grid item xs={12}>
                        <Box mb={2}>
                            <Alert variant={alertVariant} title={alertVariant === "warning" ? "" : errorMsg}>
                                {errorDesc}
                            </Alert>
                        </Box>
                    </Grid>
                )}
                {isFunctionalAreaError && (
                    <Grid item xs={12}>
                        <Box mb={2} mt={4}>
                            <Alert variant={functionalAreaAlertVariant}>
                                {functionalAreaErrorDesc}
                            </Alert>
                        </Box>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={4}>
                        <Grid item xs={8}>
                            <Card>
                                <CardContent>
                                    <Grid container>
                                        <Grid item xs={10}>
                                            {teamId ? (<>
                                                <InputLabel htmlFor="supplier">Supplier</InputLabel>
                                                <Typography variant="body1" gutterBottom>
                                                    {`${selectedSupplierName.toUpperCase()} - ${selectedSupplierNumber}`}
                                                </Typography>
                                            </>) : <>
                                                <FormControl fullWidth required component="fieldset">
                                                    <InputLabel htmlFor="supplier">Select Supplier</InputLabel>
                                                    <Controller
                                                        rules={{required: true}}
                                                        control={control}
                                                        name="supplier"
                                                        render={({onChange, value}) => (
                                                            <Autocomplete
                                                                size="small"
                                                                id="supplier"
                                                                options={options}
                                                                getOptionLabel={(option) => `${option.supplierName} - ${parseInt(option.supplierNumber)}`}
                                                                getOptionSelected={(option, value) => {
                                                                    if (!option || !value)
                                                                        return false;
                                                                    
                                                                    // Handle supplier objects
                                                                    if (option.supplierNumber && value.supplierNumber) {
                                                                        return option.supplierNumber === value.supplierNumber;
                                                                    }
                                                                    // Handle other object types that might be passed as value
                                                                    return false;
                                                                }}
                                                                loading={loading}
                                                                onChange={(e, value) => {
                                                                    handleValueChange(value)
                                                                    onChange(value)
                                                                }}
                                                                onInputChange={(e, value) => {
                                                                    if (value.length > 2)
                                                                        getSuppliersList(value)
                                                                }}
                                                                renderInput={(params) => <TextField
                                                                    {...params}
                                                                    style={{width: "80%"}}
                                                                    placeholder="Search Supplier name or number (enter 3 or  characters)"
                                                                    variant="outlined"/>
                                                                }
                                                            />
                                                        )}
                                                    />
                                                    <FormHelperText>{isSupplierNumberEmpty && "Please Select Supplier"}</FormHelperText>
                                                </FormControl>
                                            </>}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Box display="flex" justifyContent="flex-end">
                                                {supplierData.supplierInd === "Y" && (
                                                    <Chip size="small"
                                                        icon={<CheckCircleIcon style={{fill: "#367c2b"}}/>}
                                                        label={"AE Supplier"}
                                                        style={{
                                                            backgroundColor: "#D2E1CF",
                                                            fontWeight: 600,
                                                            borderRadius: ".5rem"
                                                        }}
                                                    />
                                                )}
                                                {supplierData.supplierInd === "N" && (
                                                    <Chip size="small"
                                                        icon={<ErrorIcon style={{fill: "#C21020"}}/>}
                                                        label={"Non AE Supplier"}
                                                        style={{
                                                            backgroundColor: "#F1C8CC",
                                                            fontWeight: 600,
                                                            borderRadius: ".5rem"
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Box mt={4}>
                                                <Typography variant="label" gutterBottom>
                                                    Location
                                                </Typography>
                                                <Typography variant="body1" gutterBottom>
                                                    {teamId 
                                                        ? (supplierData.supplierLocation === "" ? "N/A" : supplierData.supplierLocation)
                                                        : (!supplierData.supplierLocation ? "-" : toCapitalize(supplierData.supplierLocation))
                                                    }
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Box mt={4}>
                                                <Typography variant="label" gutterBottom>
                                                    Functional Area
                                                </Typography>
                                                <Typography variant="body1" gutterBottom>
                                                    {teamId 
                                                        ? (selectedFunctionalArea === "" ? "N/A" : selectedFunctionalArea)
                                                        : (!supplierData.functionalAreaType ? "-" : toCapitalize(supplierData.functionalAreaType))
                                                    }
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Box mt={4}>
                                                <Typography variant="label" gutterBottom>
                                                    Sub Functional Area
                                                </Typography>
                                                <Typography variant="body1" gutterBottom>
                                                    {teamId 
                                                        ? (selectedSubFunctionalArea === "" ? "N/A" : selectedSubFunctionalArea)
                                                        : ((supplierData.subFunctionalAreaObject && supplierData.subFunctionalAreaObject.description) ? toCapitalize(supplierData.subFunctionalAreaObject.description) : "-")
                                                    }
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={4}>
                            <Card style={{height: teamId ? '155px' : '170px'}}>
                                <CardContent>
                                    <Typography variant="label" gutterBottom>
                                        {SELECT_TEAM_LEAD_TEXT}
                                    </Typography>
                                    <Grid item xs={12}>
                                        <Box p={1}>
                                            <FormControl required fullWidth component="fieldset">
                                                <Controller
                                                    rules={{required: true}}
                                                    control={control}
                                                    defaultValue={selectedData}
                                                    name={"teamLead"}
                                                    render={({onChange, value}) => (
                                                        <RadioGroup
                                                            aria-label={name}
                                                            name={name}
                                                            value={selectedData}
                                                            onChange={(e) => {
                                                                onChange(e);
                                                                onRespTypeChange(e);
                                                            }}>
                                                            {sbmData.map((item) => (
                                                                <FormControlLabel
                                                                    key={item.value}
                                                                    value={item.value}
                                                                    control={<Radio/>}
                                                                    label={<>
                                                                        <Typography
                                                                            variant={"body1"}
                                                                            display="inline">
                                                                            {!item.valid && (
                                                                                <WarningIcon
                                                                                    style={{
                                                                                        fill: "#fab64c",
                                                                                        paddingRight: '.25rem'
                                                                                    }}/>
                                                                            )}
                                                                        </Typography>
                                                                        <Typography
                                                                            variant={"body1"}
                                                                            fontWeight={"semibold"}
                                                                            display="inline">{item.label}
                                                                        </Typography> {item.user}

                                                                    </>}
                                                                    disabled={item.value.indexOf("undefined") >= 0}
                                                                />
                                                            ))}
                                                        </RadioGroup>
                                                    )}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Box mb={3}>
                                <PotentialTeamMembers
                                    supplierNumber={selectedSupplierNumber || (supplierData && supplierData.supplierNumber)}
                                    excludeRacfs={stakeholdersList.filter(item => item.status !== 'D').map(item => item.user.racfID)}
                                    onAddMember={handleAddPotentialMember}
                                />
                            </Box>
                            <TeamMembersCard
                                isLoading={isLoading}
                                supplierData={supplierData}
                                selectedStakeHolders={selectedStakeHolders}
                                stakeholdersList={stakeholdersList}
                                roleList={roleList}
                                unitList={unitList}
                                updateStakeholdersList={handleUpdateStakeholder}
                                updateRacfIDEmpty={handleUpdateRacfId}
                                updateRoleEmpty={handleUpdateRole}
                                updateUnitEmpty={handleUnitEmpty}
                                updateTeamMemberEmpty={handleTeamMemberEmpty}
                                isTeamMemberEmpty={isTeamMemberEmpty}
                                updateErrorMsg={handleErrorMsg}
                                updateSelectedStakeholders={handleSelectedStakeholders}
                                addDisable={addDisable}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}
